/* eslint import/prefer-default-export: 0 */
import { createAsyncRequestTypes } from 'utils'

const ACTIVITIES = '@@ACTIVITIES@@/'

/* list audits */
export const LIST_ACTIVITIES = createAsyncRequestTypes(
  `${ACTIVITIES}LIST_ACTIVITIES`
)
